import { NO_CACHE, NO_COMPONENT_CACHE } from '../../constants/queryOptions';
import { StringBoolean } from '../../types/StringBoolean';

type QueryRecord = Record<string, string | string[] | undefined | null>;

function getFirstQueryValue(query: QueryRecord | undefined, key: string): string | undefined {

  const value = query?.[key];

  if (Array.isArray(value)) {

    return value[0] ?? undefined;

  }

  return value ?? undefined;

}

function isExplicitTrue(value: string | undefined): boolean {

  return value === StringBoolean.true;

}

export function isComponentCachingDisabled(query: QueryRecord | undefined): boolean {

  return (
    isExplicitTrue(getFirstQueryValue(query, NO_COMPONENT_CACHE)) ||
    isExplicitTrue(getFirstQueryValue(query, NO_CACHE))
  );

}

export function isPageCachingDisabled(query: QueryRecord | undefined): boolean {

  return isExplicitTrue(getFirstQueryValue(query, NO_CACHE));

}
